import { AstNode } from './types';

/** A node's source extent, [start, end) as 0-based indexes into the parsed text. */
export interface Span {
  start: number;
  end: number;
}

// Kept beside the tree rather than on it: nodes stay pure data, so a printed
// and re-parsed tree is deep-equal to the original and a transformed tree
// carries no stale positions. Transformed and printed nodes simply have none.
const spans = new WeakMap<AstNode, Span>();

export function setSpan<T extends AstNode>(node: T, span: Span): T {
  spans.set(node, span);
  return node;
}

/** Where the parser read `node` from, or undefined for a node the parser did not make. */
export function spanOf(node: AstNode): Span | undefined {
  return spans.get(node);
}
